// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"Nunito", sans-serif',
    },
    palette: {
        background: {
            default: '#fff',
        },
        text: {
            primary: '#5947a6',
        },
        primary: {
            main: '#f03093',
        },
        secondary: {
            main: '#94a3b8'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    padding: '0.5rem 3.75rem',
                    lineHeight: '2rem',
                    '&.Mui-disabled': {
                        backgroundColor: 'rgba(240, 48, 147, 0.5)', // Cor de fundo para o estado disabled
                        boxShadow: 'none',                     // Remove a sombra no estado disabled
                    },
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#5947a6',
                    '&.Mui-focused': {
                        color: '#a8b1ff', // Cor desejada ao focar
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5947a6',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5947a6', // Cor da borda ao passar o mouse
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#a8b1ff', // Cor da borda ao focar
                    },
                },
            },
        },
    }
});

export default theme;
